mutation (
  $email: AWSEmail!
  $confirmationCode: String!
  $newPassword: String!
  $locale: Locale!
) {
  confirmForgotPassword(
    email: $email
    confirmationCode: $confirmationCode
    newPassword: $newPassword
    locale: $locale
  )
}
